import { FunctionComponent, memo, useEffect, useState } from 'react';
import { FormControl, FormControlLabel, Switch } from '@material-ui/core';
import { useStockDeviceMutation } from '../../../../store/api-slice';
import { MedisanteDevice } from '../../../../pages/Device/types';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';

interface Props {
  devices: MedisanteDevice[];
  onStockDeviceChange(inStock: boolean, err: any): void;
}

const StockDeviceSwitch: FunctionComponent<Props> = memo(
  ({ devices, onStockDeviceChange }) => {
    const [stockDevicesFn, { isLoading }] = useStockDeviceMutation();
    const [stockdevice, setStockDevice] = useState(false);
    const config = useConfig();

    useEffect(() => {
      if (devices.length > 0 && devices[0].inStock) {
        setStockDevice(devices[0].inStock);
      }
    }, [devices]);

    return (
      <FormControl>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={stockdevice}
              disabled={isLoading}
              onChange={(e) => {
                stockDevicesFn({
                  apiBaseURL: config.apiBaseURL,
                  devices: devices,
                  stock: e.target.checked,
                })
                  .then((resp) => {
                    onStockDeviceChange(!e.target.checked, null);
                  })
                  .catch((err) => {
                    onStockDeviceChange(false, err.message);
                  });
              }}
            />
          }
          label="Stock"
        />
      </FormControl>
    );
  }
);

export default StockDeviceSwitch;
